var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mt-2 mb-3",style:(("width: " + _vm.width + "; height: " + _vm.height + "; margin: auto"))},[_c('doughnut-chart-initial',{attrs:{"data":_vm.donutChart.data,"options":_vm.donutChart.options}})],1),_c('div',{staticClass:"d-flex align-items-center justify-content-center flex-wrap"},_vm._l((_vm.labels),function(label,index){return _c('div',{key:index,staticClass:"d-flex align-items-center mx-50"},[_c('div',{staticClass:"mr-50",style:([
          ,
          {
            'border-radius': '3px',
            width: '18px',
            height: '4px',
            backgroundColor: _vm.colors[index],
          } ])}),_c('div',{staticClass:"small"},[_vm._v(_vm._s(label))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }